import Bootstrap from '../../vendor/Bootstrap';
import AlentoorMap from '../../vendor/AlentoorMap';

// Vendor
AlentoorMap.init();

const interactWithAlentoorMapOnHover = () => {
    const cards = document.querySelectorAll('.advertisement-card-component');

    [...cards].map((card) => {
        card.addEventListener('mouseenter', () => {
            const advertisementId = card.dataset.advertisementId;
            const event = new CustomEvent('alentoor_map:marker:highlight', {detail: {id: advertisementId}});
            window.dispatchEvent(event);
        });
    });
};

Livewire.on('advertisements:loaded', () => {
    // Adding custom interactions with map after advertisements are asynchronously loaded
    interactWithAlentoorMapOnHover();
    // Reload tooltips after advertisements are asynchronously loaded
    Bootstrap.tooltips();
});

Livewire.on('reloadPage', () => {
    window.history.replaceState(null, null, window.location.pathname);
    window.location.reload();
});
